import { ComponentStyleConfig } from '@chakra-ui/react';

const FormLabelTheme: ComponentStyleConfig = {
  baseStyle: () => ({
    fontSize: 'md',
    fontWeight: 'medium',
    textTransform: 'capitalize',

    _light: {
      color: 'black.lighter'
    },
    _dark: {
      color: 'silver.lighter'
    }
  })
};

export default FormLabelTheme;
